import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';
import qs from 'qs';

export const serviceLogService = {
  getList,
  storeOrUpdate,
  destroy,
  getItemLibrary,
  getExistingParts,
};

// Reusable service-item library (global defaults + this property's items).
function getItemLibrary(propertyId) {
  return axios
    .get(`${apiEndpoint.serviceLogs}/item-library`, { headers: authHeader(), params: { property_id: propertyId } })
    .then(res => (res && res.status === 200 && res.data.code === '0000') ? res.data : {});
}

// Distinct parts used previously across this property's service history.
function getExistingParts(propertyId) {
  return axios
    .get(`${apiEndpoint.serviceLogs}/existing-parts`, { headers: authHeader(), params: { property_id: propertyId } })
    .then(res => (res && res.status === 200 && res.data.code === '0000') ? res.data : {});
}

// List service logs for an asset, optionally within a date range.
function getList(facilityId, params = {}) {
  const queryString = qs.stringify({ facility_id: facilityId, ...params }, { addQueryPrefix: true });
  return axios
    .get(`${apiEndpoint.serviceLogs}${queryString}`, { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
      return {};
    });
}

function storeOrUpdate(data, id = null) {
  return (id
    ? axios.put(apiEndpointFunction.serviceLogs(id), data, { headers: authHeader() })
    : axios.post(apiEndpoint.serviceLogs, data, { headers: authHeader() })
  ).then(res => {
    if (res && res.status === 200) {
      return res.data;
    }
    return {};
  });
}

function destroy(id) {
  return axios
    .delete(apiEndpointFunction.serviceLogs(id), { headers: authHeader() })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    });
}
